// Keep the finder action and its outcome ahead of descriptive context. The
// first-party journey sink retains the full payload; this is only the GA copy.
const FINDER_GA_KEYS = [
  "page_location",
  "page_referrer",
  "tool",
  "target_id",
  "telemetry_schema_version",
  "finder_experience_version",
  "source_surface",
  "location_mode",
  "result_count",
  "search_state",
  "error_code",
  "attempt_number",
  "location_latency_bucket",
  "map_ready_latency_bucket",
  "recommendation_ready_latency_bucket",
  "recommendation_set_reason",
  "recommendation_set_sequence",
  "recommendation_position",
  "spot_id",
  "interaction_method",
  "filter_id",
  "query_length",
  "distance_band",
  "recommendation_count",
  "study_need",
  "place_category",
  "spot_region",
  "refinement_used",
  "finder_visitor_status",
  "preference_state",
  "visit_status",
  "device_class",
  "blog_layout_version",
  "blog_entry_mode",
] as const;

export function projectStudyFinderGaParams(
  params: Record<string, unknown>
): Record<string, unknown> {
  if (params.tool !== "study_spots_map") return params;
  const projected: Record<string, unknown> = {};
  for (const key of FINDER_GA_KEYS) {
    const value = params[key];
    if (value === undefined || value === null) continue;
    if (Object.keys(projected).length === 25) break;
    projected[key] = value;
  }
  return projected;
}
